
import HtmlRich from '@gid/vue-common/components/HtmlRich.vue';
import RichTextEditor from '@gid/vue-common/components/RichTextEditor.vue';
import { LiveAgent } from '@gid/vue-common/components/ticketing/interface/ticketing';
import axios from 'axios';
import { BModal } from 'bootstrap-vue';
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator';
import {
  MAX_PAYLOAD_SIZE_IN_MB,
  emptyLiveAgentTicket,
  validateEmails,
  validatePayloadSize,
} from '../../components/ticketing/ticketCreate';

@Component({
  components: { RichTextEditor, HtmlRich },
})
export default class TicketCreateModal extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: () => [] }) departments!: any[];
  @Prop({ default: () => [] }) agents!: any[];

  @Ref('modal') readonly modal!: BModal;

  newTicket: LiveAgent.TicketInterface = emptyLiveAgentTicket();
  selectedAgent: any = null;
  error = '';
  showLoader = false;

  get departmentOptions() {
    return (this.departments || []).map((d: LiveAgent.Department) => ({
      text: d.name,
      value: d.department_id,
    }));
  }
  get senderOptions() {
    return (this.agents || []).map((a: any) => ({
      text: `${a.name} - ${a.email}`,
      value: a,
    }));
  }

  async onCreate() {
    const fail = (msg) => {
      this.error = msg as string;
    };
    if (!this.newTicket.departmentid)
      return fail(this.$t('tickets.error.department-required'));
    if (!this.selectedAgent)
      return fail(this.$t('tickets.error.sender-required'));
    if (!this.newTicket.recipient || !validateEmails(this.newTicket.recipient))
      return fail(this.$t('tickets.error.recipient-required'));
    if (
      this.newTicket.carbon_copies &&
      !validateEmails(this.newTicket.carbon_copies)
    )
      return fail(this.$t('tickets.error.invalid-cc-email'));
    if (
      this.newTicket.blind_carbon_copies &&
      !validateEmails(this.newTicket.blind_carbon_copies)
    )
      return fail(this.$t('tickets.error.invalid-bcc-email'));
    if (!this.newTicket.subject)
      return fail(this.$t('tickets.error.subject-required'));
    if (!this.newTicket.message)
      return fail(this.$t('tickets.error.message-required'));

    const payload = {
      ...this.newTicket,
      carbon_copies: (this.newTicket.carbon_copies || '').trim(),
      agentid: this.selectedAgent.id,
      useridentifier: this.selectedAgent.email,
      jobIds: [],
    };

    const sizeCheck = validatePayloadSize(payload, MAX_PAYLOAD_SIZE_IN_MB);
    if (!sizeCheck.isValid) {
      return fail(
        this.$t('tickets.error.payload-too-large', {
          size: sizeCheck.sizeInMB.toFixed(2),
          max: MAX_PAYLOAD_SIZE_IN_MB,
        }),
      );
    }

    try {
      this.showLoader = true;
      this.error = '';
      await axios.post('/data-api/ticket', payload);
      this.ticket_created();
      this.clear();
      this.close();
    } catch (e) {
      this.error = this.$t('tickets.error.create-failed') as string;
    } finally {
      this.showLoader = false;
    }
  }

  clear() {
    this.newTicket = emptyLiveAgentTicket();
    this.selectedAgent = null;
    this.error = '';
  }

  @Emit('ticket-created')
  ticket_created() {
    return true;
  }
  @Emit('close')
  close() {
    return true;
  }
}
